<div class="d-flex flex-column gap-48 overflow-hidden">
  <app-main-section id="main"/>
  <app-experience-section id="experience"/>
  <app-about-section id="about"/>
  <app-blog id="news"/>
  <app-contact-section id="contact"/>
  <app-footer/>
</div>